/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API75130Req {
  
  /** 会话标识Id */
  sessionToken?: string;
  /** 会话名称 */
  sessionName?: string;
};



export type API75130Res = boolean;


// 接口函数 75130 修改名称

export interface IUsePostAPI75130Return {
  /** 修改名称: 接口请求状态 */
  isAPI75130Loading: boolean;
  /** 修改名称: 接口请求返回数据 */
  dataAPI75130: API75130Res;
  /**  修改名称: 接口数据请求方法 */
  fetchAPI75130Data: (inputs: API75130Req, config?: YWRequestConfig) => Promise<API75130Res>;
  /** 修改名称: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75130 = ():IUsePostAPI75130Return => {
  let isMount = true;
  const [isAPI75130Loading, setIsAPI75130Loading] = useState(false);
  const [dataAPI75130, setDataAPI75130] = useState<API75130Res>({} as API75130Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/session/name/modify`;

  const fetchAPI75130Data = async (inputs: API75130Req, config?: YWRequestConfig): Promise<API75130Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75130Req>) || {}) as API75130Req;
    
  
    if ( isMount ) {
      setIsAPI75130Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75130Res>(`${basePath}/yoaichat-web/chat/session/name/modify`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75130(res || {} as API75130Res);
        setIsAPI75130Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75130Loading(false);
      }
      return false as unknown as API75130Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75130Loading,
    dataAPI75130,
    fetchAPI75130Data,
    requestUrl,
  }
}

